import { availablePackage } from './models/availablePackage';
import { FileUploadService } from './service/file-upload.service';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
//@ts-ignore
import { software_update } from "../assets/conf_urls.json";
import { HttpClient } from "@angular/common/http";
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';

const URL = 'http://echuqu013vw.internal.vodafone.com:3001/api/upload';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css'],
  providers: [FileUploadService]
})
export class FileUploaderComponent implements OnInit, AfterViewInit {
  title = 'Upload a File';
  show_alert_upload_status = false
  show_alert_upload_msg = ""
  public uploader: FileUploader = new FileUploader({ url: URL, itemAlias: 'file' });
  response: string;

  //new attributes for the packages table
  packagesAvailable: availablePackage[] = [];
  displayedColumns: string[] = ['id', 'file_name', 'file_path', 'size'];
  tableData: MatTableDataSource<availablePackage> = new MatTableDataSource([]);;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private http: HttpClient,
    private fileUploadService: FileUploadService,
    private elem: ElementRef,
    private loggerService: LoggerService) {

  }

  ngOnInit(): void {
    this.getData();
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {

      this.show_alert_upload_msg = "Upload Completed"
      this.show_alert_upload_status = true
      this.update_packages_list()
    };

  }


  ngAfterViewInit(): void {
    //to adjust the headers of the table
    //(document.querySelector('.mat-sort-header-container') as HTMLElement).style.justifyContent='center';
    const elements = this.elem.nativeElement.querySelectorAll('.mat-sort-header-container');
    elements.forEach(element => {
      element.style.justifyContent = 'center';
    });
  }

  getData() {
    this.resetTable();
    this.fileUploadService.getAll().subscribe(response => {
      this.packagesAvailable = response.data;
      this.tableData = new MatTableDataSource(this.packagesAvailable);
      this.tableData.paginator = this.paginator;
      this.tableData.sort = this.sort;
    }, err => {
      this.loggerService.log("FileUploaderComponent", err.message, Levels.error)
    });
  }

  resetTable() {
    this.packagesAvailable = [];
    this.tableData = new MatTableDataSource(this.packagesAvailable);
    this.tableData.paginator = this.paginator;
    this.tableData.sort = this.sort;
  }
  update_packages_list() {
    this.http.post(software_update.services, {
      "file_path": software_update.package_directory,
      "event": "reload_packages_list"
    }).subscribe(data => {
    }, err => {
      this.loggerService.log("FileUploaderComponent", err.message, Levels.error)
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tableData.filter = filterValue.trim().toLowerCase();
    if (this.tableData.paginator) {
      this.tableData.paginator.firstPage();
    }
  }
}
